import React, { useEffect } from 'react';
import Intercom from '@intercom/messenger-js-sdk';
import useLocalStorage from '../hooks/useLocalStorage';

const IntercomSupport = () => {
  const intercomAppId = "dwujlxht";
  const [verificationJWT] = useLocalStorage('verificationJWT');

  useEffect(() => {
    let userData = { app_id: intercomAppId };
    
    if (verificationJWT) {
      try {
        const jwtData = typeof verificationJWT === 'string' ? JSON.parse(verificationJWT) : verificationJWT;
        const verification = jwtData?.verification;
        
        if (verification) {
          userData = {
            ...userData,
            user_id: verification.subject,
            name: verification.full_name,
            email: verification.email,
          };
        }
      } catch (error) {
        console.warn('Error parsing JWT:', error);
      }
    }

    Intercom(userData);
  }, [intercomAppId, verificationJWT]);

  // This component just initializes Intercom, it doesn't render anything
  // Intercom will render its own button automatically
  return null;
};

export default IntercomSupport;
